import { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { MenuProvider } from "./Hooks/menuContext";
import About from "./components/About";
import Education from "./components/Education";
import Navbar from "./components/Navbar";
import Resume from "./components/Resume";
import Sidebar from "./components/Sidebar";
import Skills from "./components/Skills";
import Touch from "./components/Touch";
import "./scss/app.scss";

function App() {
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = () => setWidth(window.innerWidth);
  useEffect(() => (window.onresize = updateWidth), []);

  return (
    <div className="app">
      <Router>
        <MenuProvider>
          <Navbar />
          <div className="components">
            {width >= 600 ? <Sidebar /> : null}
            <div className="right">
              <About />
              <Skills />
              <Resume />
              <Education />
              <Touch />
            </div>
          </div>
        </MenuProvider>
      </Router>
    </div>
  );
}

export default App;
